import Layout from '@/views/Layout.vue'

import legal from './legal'
import maintenance from './maintenance'
import login from './login'
import campus from './campus'
import utility from './utility'
import transit from './transit'

export default [
    {
        path: '/',
        name: 'home',
        redirect: '/campus'
    },
    legal,
    maintenance,
    login,
    campus,
    utility,
    transit,
    {
        path: '/*',
        component: Layout,
        children: [
            {
                path: '',
                name: '404',
                component: () => import('@/views/404.vue')
            }
        ]
    }
]
